/**
 /**
 * created by tianruojun
 * 媒体code与网站稿件查询接口之间的关系
 */
 export const showStoryUrlConfig = {
    "webNews": {
        idKey: "contentId",
        module: "materialCenterStoryEditor",
        pickerModule: "webEditor",
        urls: {
            titleUrl:"/cm-sites-pms/story/renderWebNewsByStory",
            pickerUrl:"/cm-sites-media-consumer/position/content/manager/pickUp",
        },
    },
    "material": {
        style: "noAjax",
        openModule:{
            configName: "materialCenterStoryEditor",
            id : "${id}",
            params: {
                activitiConfName:"activitiTreeRoot-xlc-sczxwxlc"
            }
        }
    },
    "rmapp": {
        idKey: "contentId",
        module: "rmAppEditor",
        url: "/cm-sites-media-consumer/position/content/manager/pickUp"
    },
    "default": {
        idKey: "webNewsId",
        module: "webEditor",
        url: "/cm-sites-pms/website/news/getById"
    },
    "manuscriptsSubmitted": {
        style: "noAjax",
        openModule:{
            configName: "materialCenterStoryEditor",
            id : "${id}",
            params: {
                activitiConfName:"activitiTreeRoot-xlc-sczxsglc"
            }
        }
    }
};
